<template>
    <div class="tw-tickets tw-stage tw-stage--padded">
        <div class="tw-items tw-responsive__xs--half-padding tw-responsive__xxs--half-padding">
            <div class="tw-item tw-item--muted">
               <p class="tw-text--center">{{ errorMessage }}</p>
            </div>
        </div>
    </div>
</template>

<script lang='ts'>
    import { Vue } from "vue-property-decorator";
    import { Component, Prop } from "vue-property-decorator";
    import moment from 'moment-timezone';
    import TicketWidgetComponent from '../../TicketWidgetComponent';

    @Component({})

    export default class ErrorHandling extends TicketWidgetComponent {
        @Prop() public errorMessage!: string;
    }
</script>